import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { Form, Control, Errors } from 'react-redux-form';
import nameof from '../../utils/nameof';
import { RegistrationPromptModel } from './RegisterUserModels';
import { renderNewTextField, renderErrorInfoText } from '../../common/forms/FieldCreators';
import { OnSubmitFormProps } from '../../common/props/commonFormProps';
import { localizations } from '../../localization/localization';
import * as companyApi from '../../api/companyApi'
import * as validators from '../../common/validators/formValidators'

const styles = (theme: Theme) => ({
    container: {
        padding: theme.spacing(4),
    },
    textField: {
        width: "300px"
    }
})

interface PromptProps {
    onRegisterCompany: () => void;
}

type PromptRegistrationIdentifierFormProps = PromptProps & OnSubmitFormProps<RegistrationPromptModel> & WithStyles<"container" | "textField">;

const PromptRegistrationIdentifierForm: React.SFC<PromptRegistrationIdentifierFormProps> = (props) => {

    const { onSubmit, classes, onRegisterCompany } = props;

    return (
        <Form hideNativeErrors model="registrationPrompt" onSubmit={onSubmit}>
            <Grid container className={classes.container} direction="column" alignItems="center" justify="flex-start">
                <Typography paragraph variant="h4">{localizations.register.registerUserTitle}</Typography>
                <Typography paragraph variant="body2">{localizations.register.ifIdentifierMissing}</Typography>
                <Control.text model={`.${nameof<RegistrationPromptModel>("identifier")}`} required label={localizations.common.companyIdentifier} component={renderNewTextField} className={classes.textField}
                    validators={{
                        isRequired: validators.required
                    }}
                    asyncValidators={{
                        found: (val, done) => {
                            companyApi.findCompanyWithRegistrationId(val).then((response) => {
                                if (response) {
                                    done(true);
                                } else {
                                    done(false)
                                }
                            })
                        }
                    }}
                    asyncValidateOn="blur" />
                <Errors model={`.${nameof<RegistrationPromptModel>("identifier")}`} messages={{
                    found: localizations.validation.identifierNotFound,
                    isRequired: localizations.validation.required
                }}
                    wrapper={renderErrorInfoText} />
                <div><br /></div>
                <Button variant="contained" type="submit" color="primary">{localizations.actions.continue}</Button>
                <div><br /></div>

                <Button variant="text" color="secondary" onClick={onRegisterCompany}><Typography>{localizations.register.doNotHaveIdentifier}</Typography></Button>
            </Grid>
        </Form>
    );
};
export default withStyles(styles)(PromptRegistrationIdentifierForm);


// WEBPACK FOOTER //
// ./src/register/user/PromptRegistrationIdentifierForm.tsx